<template>
  <div class="btn-container has-no-style" v-show="!hideBackButton">
    <div
      :class="[isColumn ? 'column btn-inner style-wrap' : 'btn-inner style-wrap',
      activeButton ? 'btn-active' : '',
      (isCollectButton || isLikeButton) ? 'btn-collect-like' : '']"
      ref="btnInner"
      :style="getTextStyle"
      @click.stop="textClickEvent"
    >
      <!--ip组件的前缀文案-->
      <span v-if="ipPreContent && ipPreContent.length>0 && (getIconPosition === 'right' || getIconPosition === 'bottom')" :style="ipPreContentStyle">{{ipPreContent}}</span>
      <span
        v-if="(getIconPosition === 'right' || getIconPosition === 'bottom')"
        :class="[contentHasLimit ? 'overflowHidMultiLine' : '', getIconPosition === 'right' ? 'inlineBlock' : '']"
        :style="colorStyle"
        v-html="getTextContent"
        ref="btnInner"
        @dblclick.self="dbEditContent($event)"
        @blur="dbChangeContent($event)"
        :contenteditable="isEditStatu"
      ></span>
      <span v-if="isLikeButton && (getIconPosition === 'right' || getIconPosition === 'bottom')"
            :class="[getIconPosition === 'right' ? 'inlineBlock' : '']"
            :style="colorStyle"
      >{{likeNumber}}</span>
      <cxIcon v-if="iconSrc && !isCollectLike" :options="options" :iconStyle="getIconStyle"></cxIcon>
      <cxIcon v-if="iconSrc1 && isCollectLike" :options="options" :iconStyle="getIconStyle" :iconSrcDefault="iconSrc1"></cxIcon>
      <!--ip组件的前缀文案-->
      <span v-if="ipPreContent && ipPreContent.length>0 && (getIconPosition === 'left' || getIconPosition === 'top')" :style="ipPreContentStyle">{{ipPreContent}}</span>
      <span
        v-if="(getIconPosition === 'left' || getIconPosition === 'top')"
        :class="[contentHasLimit ? 'overflowHidMultiLine' : '', getIconPosition === 'left' ? 'inlineBlock' : '']"
        :style="colorStyle"
        v-html="getTextContent"
        ref="btnInner"
        @dblclick.self="dbEditContent($event)"
        @blur="dbChangeContent($event)"
        :contenteditable="isEditStatu"
      ></span>
      <span v-if="isLikeButton && (getIconPosition === 'left' || getIconPosition === 'top')"
            :class="[getIconPosition === 'left' ? 'inlineBlock' : '']"
            :style="colorStyle"
      >{{likeNumber}}</span>
    </div>
    <!-- 在预览页使用 -->
    <tipsDialog v-if="showDialog" :visible.sync="showDialog" :rectOptions="rectOptions"></tipsDialog>
  </div>
</template>

<script>
import { parseColor } from "@/utils/parseColor"
import { isSsrPage } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import plugins from "./plugin"
import tipsDialog from "./tipsDialog.vue"
import dataRenderMixin from "materials/dataRenderMixin"
import {compareIds} from "utils/event/animate";

export default {
  mixins: [eventMixin, plugins, dataRenderMixin],
  components: { tipsDialog },
  name: "cxButton",
  props: {
    type: { type: String },
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      iconContent: "",
      showDialog: false,
      rectOptions: {},
      isEditStatu: false,
      tempContent: "",
      activeButton: false, //按钮被选中
      likeNumber: 0, //点赞按钮的数量
      isCollectLike: false,  //是否是收藏/点赞按钮
      hideBackButton: false,  //返回按钮的属性
    }
  },
  watch: {
    "options.detailFieldMapping": {
      deep: true,
      handler(n) {
        if (n) {
          this.updateData()
        }
      }
    },
    "ids":{
      deep:true,
      handler(n,o) {
        if(this.isEditStatu && !compareIds(n,this.myid)){
           this.dbChangeContent()
        }
      }
    }
  },
  created() {
    // 返回按钮的显示
    if(this.isReturnButton){
      let hide = this.options.hasOwnProperty("hideBackButton") ? this.options.hideBackButton : false
      if(hide){
        if(window.history.length <= 1){
          // 跳转设置为新页面打开
          this.hideBackButton = true
        } else if(document.referrer === ""){
          // 复制预览地址直接打开
          this.hideBackButton = true
        } else if (performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD &&
            performance.navigation.redirectCount === 0) {
          // 是通过 history.go(-1) 进入页面的
          // performance.navigation 在某些浏览器中可能不可用或者不完整: chrome4-9,safari3.1-7.1,firfox2-6,opera10-12.1,ie6-8,
          this.hideBackButton = true
        } else {
          this.hideBackButton = false
        }
      }
    }
  },
  mounted() {
    ////编辑页不需要运行插件就在插件内部通过isSsrPage来判断环境后，再由插件内部自行决定是否运行
    this.$initPlugin(this.options?.pluginName)
    this.$nextTick(() => {
      this.clearOptionsCover()
      document.addEventListener("keydown", this.keyDownEvent)

      // todo 调试暂用
      // submitInputValue(this)

      if(this.isCollectButton || this.isLikeButton){
        //编辑页预先设置为默认状态
        this.$changeOptionsEV(0, "iconSrcType1", false, null, this.myid)
        this.isCollectLike = true
      }
    })
    if (
      this.noCacheComponent &&
      ((!this.options?.filedMapping?.flag && this.options.appId) || this.options?.detailFieldMapping?.isChecked)
    ) {
      this.updateData()
    }
    if(this.options?.pluginName?.includes("popoverPlugin")) {
      this.$changeOptionsEV(false, "openPopover", false, null, this.myid, true)
      this.$eventBus.$on("control-popover", this.handlePopover)
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyDownEvent)
    if(this.options?.pluginName?.includes("popoverPlugin")) {
      this.$eventBus.$off("control-popover", this.handlePopover)
    }
  },
  computed: {
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    getTextContent() {
      if(this.isIp && !this.options.isShowIp){
        return ""
      }
      let content1, textLimitLines
      if(this.isCollectLike){
        content1 = this.getTextContent_content
        textLimitLines = this.getTextContent_textLimitLines
      }else{
        content1 = this.options.content
        textLimitLines = this.options.textLimitLines
      }
      let content = this.options
        ? String(content1)
            ?.replace("&lt;&gt;", "<>")
            .replace(/(<br>)*$/g, "")
        : ""
      let data = this.contentHasLimit ? content?.substr(0, textLimitLines) : content
      // 添加直接省略和添加省略号
      data = this.options.wordOmitType === "ellipsis" && content && content.length > textLimitLines ? data+'...' :data
      return data
    },
    iconSrc() {
      let iconSrc, showIcon = false
      if(this.isCollectLike){
        iconSrc = this.getTextContent_iconSrc
        showIcon = this.getTextContent_showIcon
      }else{
        let iconSrcType = Number(this.options.iconSrcType)
        switch (iconSrcType) {
          case 0:
            iconSrc = this.options.iconSrc
            break
          case 1:
            iconSrc = this.options.hoverIconSrc
            break
          case 2:
            iconSrc = this.options.clickIconSrc
            break
          default:
            iconSrc = this.options.iconSrc
        }
        showIcon = this.options.showIcon
      }
      return iconSrc && showIcon !== false
    },
    iconSrc1() {
      let iconSrc1 = ""
      if(this.isCollectLike){
        iconSrc1 = this.getTextContent_iconSrc
      }
      return iconSrc1
    },
    getIconPosition() {
      let iconPosition
      if(this.isCollectLike){
        iconPosition = this.getTextContent_iconPosition
      }else{
        iconPosition = this.options.iconPosition
      }
      return iconPosition || "left"
    },
    isColumn() {
      if (this.getIconPosition === "top" || this.getIconPosition === "bottom") return true
      else return false
    },
    getMargin() {
      let iconMargin
      if(this.isCollectLike){
        iconMargin = this.getTextContent_iconMargin
      }else{
        iconMargin = this.options.iconMargin
      }
      return this.getIconPosition === "left"
        ? `0 ${iconMargin}px 0 0`
        : this.getIconPosition === "right"
        ? `0 0 0 ${iconMargin}px`
        : this.getIconPosition === "top"
        ? `0 0 ${iconMargin}px 0`
        : `${iconMargin}px 0 0 0`
    },
    contentHasLimit() {
      let contentHasLimit
      if(this.isCollectLike){
        contentHasLimit = this.getTextContent_contentHasLimit
      }else{
        contentHasLimit = this.options.contentHasLimit
      }
      return contentHasLimit || false
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            if (bg.imgUrl) {
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
            }
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            containerBg.backgroundImage = this.setBorderColor(containerBg.backgroundColor,containerBg.backgroundImage)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      if (this.options.showBorder !== false && this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor)) {
        containerBg.backgroundClip = "padding-box,border-box"// 圆角裁切
        containerBg.backgroundOrigin = "padding-box,border-box"
      }
      return containerBg
    },
    getIconStyle() {
      let iconColorIsThemeColor, iconColor, iconWidth
      if(this.isCollectLike){
        iconColorIsThemeColor = this.getTextContent_iconColorIsThemeColor
        iconColor = this.getTextContent_iconColor
        iconWidth = this.getTextContent_iconWidth
      }else{
        iconColorIsThemeColor = this.options.iconColorIsThemeColor
        iconColor = this.options.iconColor
        iconWidth = this.options.iconWidth
      }
      return {
        display: "inline-block",
        verticalAlign: "middle",
        // "--color": iconColorIsThemeColor
        //   ? this.themeColor
        //     : iconColor && iconColor.color ? iconColor.color : iconColor,
        "--color": this.$parseColor(iconColor, {isThemeColor: iconColorIsThemeColor}),
        fontSize: iconWidth + "px",
        width: iconWidth + "px",
        minWidth: iconWidth + "px",
        height: iconWidth + "px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      let iconWidth
      if(this.isCollectLike){
        iconWidth = this.getTextContent_iconWidth
      }else{
        iconWidth = this.options.iconWidth
      }
      return {
        width: iconWidth + "px",
        margin: this.getMargin
      }
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    boxShadowStyle() {
      let boxShadowH, boxShadowV, boxShadowBlur, boxShadowSpread, boxShadowColor
      if(this.isCollectLike){
        boxShadowH = this.getTextContent_boxShadowH
        boxShadowV = this.getTextContent_boxShadowV
        boxShadowBlur = this.getTextContent_boxShadowBlur
        boxShadowSpread = this.getTextContent_boxShadowSpread
        boxShadowColor = this.getTextContent_boxShadowColor
      }else{
        boxShadowH = this.options.boxShadowH
        boxShadowV = this.options.boxShadowV
        boxShadowBlur = this.options.boxShadowBlur
        boxShadowSpread = this.options.boxShadowSpread
        boxShadowColor = this.options.boxShadowColor
      }
      let tmpStyle = ""
      if (Array.isArray(boxShadowH)) {
        boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${boxShadowH[index]}px ${boxShadowV[index]}px ${boxShadowBlur[index]}px ${boxShadowSpread[index]}px ${this.$parseColor(boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${boxShadowH}px ${boxShadowV}px ${boxShadowBlur}px ${boxShadowSpread}px ${this.$parseColor(boxShadowColor)}`
      }
      return tmpStyle
    },
    textShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.textShadowH)) {
        this.options.textShadowH.forEach((item, index) => {
          if (index > 0) {
            // tmpStyle += ","
            tmpStyle += " "
          }
          tmpStyle += `drop-shadow(${this.options.textShadowH[index]}px ${this.options.textShadowV[index]}px ${this.options.textShadowBlur[index]}px ${this.$parseColor(this.options.textShadowColor[index])})`
        })
      } else {
        tmpStyle += `drop-shadow(${this.options.textShadowH}px ${this.options.textShadowV}px ${this.options.textShadowBlur}px ${this.$parseColor(this.options.textShadowColor)})`
      }
      return tmpStyle
    },
    colorStyle() {
      let colorArr, textIsThemeColor, textLimitLines, color
      if(this.isCollectLike){
        textLimitLines = this.getTextContent_textLimitLines
        colorArr = this.getTextContent_colorArr
        textIsThemeColor = this.getTextContent_textIsThemeColor
        color = this.getTextContent_color
      }else{
        textLimitLines = this.options.textLimitLines
        colorArr = this.checkAndSetPrimaryVal(this.options, "colorArr", "colorArr", "{}")
        // textIsThemeColor = this.options.textIsThemeColor
        textIsThemeColor = colorArr?.hasOwnProperty("themeColorId") ? colorArr.isThemeColor : this.options.textIsThemeColor
        color = this.options.color
      }
      let colorStyle = {}
      let tmp = []
      if (this.options) {
        if (textIsThemeColor) {
          colorStyle = {
            color: this.themeColor
          }
        } else {
          if (!(JSON.parse(JSON.stringify(colorArr)) == "{}")) {
            colorArr.data.stops.forEach(item => {
              tmp.push(item[0] + " " + item[1] * 100 + "%")
            })
            if (colorArr.label === "线性渐变") {
              colorStyle = {
                color: "transparent",
                backgroundImage: this.$parseColor(colorArr),
                "-webkit-background-clip": "text",
                "-webkit-line-clamp": textLimitLines
              }
            } else if (colorArr.label === "颜色") {
              colorStyle = {
                color: this.$parseColor(colorArr, {isThemeColor: textIsThemeColor}),
                "-webkit-line-clamp": textLimitLines
              }
            }
          } else {
            colorStyle = {
              // color: textIsThemeColor ? this.themeColor : color,
              color: this.$parseColor(color, {
                isThemeColor: textIsThemeColor
              }),
              "-webkit-line-clamp": textLimitLines
            }
          }
        }
        return colorStyle
      } else return null
    },
    getPaddingStyle() {
      let padding1, paddingTypeFlag, paddingTop, paddingRight, paddingBottom, paddingLeft
      if(this.isCollectLike){
        padding1 = this.getTextContent_padding
        paddingTypeFlag = this.getTextContent_paddingTypeFlag
        paddingTop = this.getTextContent_paddingTop
        paddingRight = this.getTextContent_paddingRight
        paddingBottom = this.getTextContent_paddingBottom
        paddingLeft = this.getTextContent_paddingLeft
      }else{
        padding1 = this.options.padding
        paddingTypeFlag = this.options.paddingTypeFlag
        paddingTop = this.options.paddingTop
        paddingRight = this.options.paddingRight
        paddingBottom = this.options.paddingBottom
        paddingLeft = this.options.paddingLeft
      }
      let padding = `${padding1}px`
      if (paddingTypeFlag === 2) {
        padding = `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`
      }
      return padding
    },
    alignStyle() {
      let textAlign1
      if(this.isCollectLike){
        textAlign1 = this.getTextContent_textAlign
      }else{
        textAlign1 = this.options.textAlign
      }
      let alignStyleObj = {}
      let alignItems = "center",
        textAlign = "center"
      // 兼容之前有textAlign属性，但是textAlign为left,但是按钮显示默认为center
      if (this.options.hasTextAlign) {
        switch (textAlign1) {
          case "left":
            alignItems = "flex-start"
            textAlign = "left"
            break
          case "center":
            alignItems = "center"
            textAlign = "center"
            break
          case "right":
            alignItems = "flex-end"
            textAlign = "right"
            break
          default:
        }
      }
      if (this.getIconPosition === "top" || this.getIconPosition === "bottom") {
        alignStyleObj = {
          alignItems: alignItems,
          textAlign: textAlign
        }
      } else {
        alignStyleObj = {
          justifyContent: alignItems,
          textAlign: textAlign
        }
      }
      return alignStyleObj
    },
    activeBg() {
      let curBackground = this.options.activeBackground
      return this.getContainerBgStyle(curBackground, this.options.activeBgColorIsThemeColor)
    },
    activeBgStyle() {
      if(this.isCollectButton || this.isLikeButton){
        return {
          "--activeBackgroundImage": this.activeBg.backgroundImage,
          "--activeBackgroundSize": this.activeBg.backgroundSize,
          "--activeBackgroundPosition": this.activeBg.backgroundPosition,
          "--activeBackgroundRepeat": this.activeBg.backgroundRepeat,
          "--activeBackgroundColor": this.activeBg.backgroundColor
        }
      }else{
        return {}
      }
    },
    hoverBgStyle() {
      if(this.isCollectButton || this.isLikeButton){
        if (this.options.hoverIsSameActive) {
          return {
            "--hoverBackgroundImage": this.activeBg.backgroundImage,
            "--hoverBackgroundSize": this.activeBg.backgroundSize,
            "--hoverBackgroundPosition": this.activeBg.backgroundPosition,
            "--hoverBackgroundRepeat": this.activeBg.backgroundRepeat,
            "--hoverBackgroundColor": this.activeBg.backgroundColor
          }
        }
        let curBackground = this.options.hoverBackground
        let containerBg = this.getContainerBgStyle(curBackground, this.options.hoverBgColorIsThemeColor)
        return {
          "--hoverBackgroundImage": containerBg.backgroundImage,
          "--hoverBackgroundSize": containerBg.backgroundSize,
          "--hoverBackgroundPosition": containerBg.backgroundPosition,
          "--hoverBackgroundRepeat": containerBg.backgroundRepeat,
          "--hoverBackgroundColor": containerBg.backgroundColor
        }
      }else{
        return {}
      }
    },
    isCollectButton() {
      return this.options && this.options.pluginName && this.options.pluginName.includes("collectPlugin")
    },
    isLikeButton() {
      return this.options && this.options.pluginName && this.options.pluginName.includes("likePlugin")
    },
    isReturnButton() {
      return this.options && this.options.pluginName && this.options.pluginName.includes("returnPlugin")
    },
    getTextStyle() {
      if (this.options) {
        let borderW = "", activeBorderW = "", hoverBorderW = ""
        this.checkAndSetVal(this.options, "borderWidth", "borderWidth", 1)
        if (Array.isArray(this.options.borderWidth)) {
          this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${this.options.borderWidth}px`
        }
        if(this.isCollectButton || this.isLikeButton){
          //选中
          if (Array.isArray(this.options.activeBorderWidth)) {
            this.options.activeBorderWidth.forEach(item => [(activeBorderW += ` ${item}px`)])
          } else {
            activeBorderW += ` ${this.options.activeBorderWidth}px`
          }
          //悬浮
          if (Array.isArray(this.options.hoverBorderWidth)) {
            this.options.hoverBorderWidth.forEach(item => [(hoverBorderW += ` ${item}px`)])
          } else {
            hoverBorderW += ` ${this.options.hoverBorderWidth}px`
          }
        }
        let cursor
        if (this.request_prefix === "bigScreen" && this.isBigScreenPreview()) {
          cursor = this.options.cursorType ? this.options.cursorType : this.options.linkUrl ? "pointer" : "default"
        }
        let thisStyle = {
          ...this.alignStyle,
          height: `100%`,
          // height: this.options.heightType === '%'?`${this.options.height}% ` : `${this.options.height}px`,
          // height: this.options.heightType === '%'?`calc(${this.options.height}% - ${this.paddingH}px)` : `${this.options.height-this.paddingH}px`,
          "letter-spacing":
            this.options.letterSpacingType === "%"
              ? this.options.letterSpacing / 100 + "em"
              : this.options.letterSpacing + "px",
          "text-indent":
            this.options.letterSpacingType === "%"
              ? this.options.letterSpacing / 100 + "em"
              : this.options.letterSpacing + "px",
          "font-style": `${this.options.fontStyle}`,
          "font-family": this.options.fontFamily,
          opacity: this.options.opacity,
          color: this.$parseColor(this.options.color, {
            isThemeColor: this.options.textIsThemeColor
          }),
          // color: this.options.textIsThemeColor ? this.themeColor : this.options.color,
          "font-size": this.options.fontSize + "px",
          "font-weight": this.options.fontWeight,
          "text-decoration": this.options.textDecoration,
          transform: "rotate(" + this.options.rotate + "deg)",
          "border-style": this.options.borderStyle,
          "border-color": this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor) ? "transparent" : this.$parseColor(this.options.borderColor, {
            isThemeColor: this.options.borderIsThemeColor
          }),
          // "border-color": this.options.borderIsThemeColor
          //   ? this.themeColor
          //   : this.options.borderColor.color
          //   ? this.options.borderColor.color
          //   : this.options.borderColor,
          "border-width": this.options.showBorder !== false ? borderW : 0,
          "box-shadow": this.boxShadowStyle,
          "filter": this.textShadowStyle,
          "writing-mode": this.options.writingMode,
          "border-top-left-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderTopLeftRadius + "px",
          "border-top-right-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderTopRightRadius + "px",
          "border-bottom-left-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderBottomLeftRadius + "px",
          "border-bottom-right-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderBottomRightRadius + "px",
          cursor: cursor,
          padding: this.getPaddingStyle
        }
        // 选中 样式
        let thisActiveStyle = {}, thisHoverStyle = {}
        if(this.isCollectButton || this.isLikeButton){
          thisActiveStyle = {
            "--activeLetterSpacing":
                this.options.activeLetterSpacingType === "%"
                    ? this.options.activeLetterSpacing / 100 + "em"
                    : this.options.activeLetterSpacing + "px",
            "--activeFontStyle": `${this.options.activeFontStyle}`,
            "--activeFontFamily": this.options.activeFontFamily,
            "--activeOpacity": this.options.activeOpacity,
            "--activeFontSize": this.options.activeFontSize + "px",
            "--activeFontWeight": this.options.activeFontWeight,
            "--activeTextDecoration": this.options.activeTextDecoration,
            "--activeRotate": "rotate(" + this.options.activeRotate + "deg)",
            "--activeBorderStyle": this.options.activeBorderStyle,
            "--activeBorderColor": this.$parseColor(this.options.activeBorderColor, {
              isThemeColor: this.options.activeBorderIsThemeColor
            }),
            // "--activeBorderColor": this.options.activeBorderIsThemeColor
            //     ? this.themeColor
            //     : this.options.activeBorderColor && this.options.activeBorderColor.color
            //         ? this.options.activeBorderColor.color
            //         : this.options.activeBorderColor,
            "--activeBorderWidth": this.options.activeShowBorder ? activeBorderW : 0,
            "--activeWritingMode": this.options.activeWritingMode,
            "--activeBorderTopLeftRadius": this.options.activeBorderTopLeftRadius + "px",
            "--activeBorderTopRightRadius": this.options.activeBorderTopRightRadius + "px",
            "--activeBorderBottomLeftRadius": this.options.activeBorderBottomLeftRadius + "px",
            "--activeBorderBottomRightRadius": this.options.activeBorderBottomRightRadius + "px",
          }
          // 选中 样式
          thisHoverStyle = {
            "--hoverLetterSpacing":
                this.options.hoverIsSameActive ? thisActiveStyle["--activeLetterSpacing"] : this.options.hoverLetterSpacingType === "%"
                    ? this.options.hoverLetterSpacing / 100 + "em"
                    : this.options.hoverLetterSpacing + "px",
            "--hoverFontStyle": this.options.hoverIsSameActive ? thisActiveStyle["--activeFontStyle"] : `${this.options.hoverFontStyle}`,
            "--hoverFontFamily": this.options.hoverIsSameActive ? thisActiveStyle["--activeFontFamily"] : this.options.hoverFontFamily,
            "--hoverOpacity": this.options.hoverIsSameActive ? thisActiveStyle["--activeOpacity"] : this.options.hoverOpacity,
            "--hoverFontSize": this.options.hoverIsSameActive ? thisActiveStyle["--activeFontSize"] : (this.options.hoverFontSize + "px"),
            "--hoverFontWeight": this.options.hoverIsSameActive ? thisActiveStyle["--activeFontWeight"] : this.options.hoverFontWeight,
            "--hoverTextDecoration": this.options.hoverIsSameActive ? thisActiveStyle["--activeTextDecoration"] : this.options.hoverTextDecoration,
            "--hoverRotate": this.options.hoverIsSameActive ? thisActiveStyle["--activeRotate"] : ("rotate(" + this.options.hoverRotate + "deg)"),
            "--hoverBorderStyle": this.options.hoverIsSameActive ? thisActiveStyle["--activeBorderStyle"] : this.options.hoverBorderStyle,
            "--hoverBorderColor": this.$parseColor(this.options.hoverBorderColor, {
              isThemeColor: this.options.hoverBorderIsThemeColor
            }),
            // "--hoverBorderColor": this.options.hoverIsSameActive ? thisActiveStyle["--activeBorderColor"] : (this.options.hoverBorderIsThemeColor
            //     ? this.themeColor
            //     : this.options.hoverBorderColor && this.options.hoverBorderColor.color
            //         ? this.options.hoverBorderColor.color
            //         : this.options.hoverBorderColor),
            "--hoverBorderWidth": this.options.hoverIsSameActive ? thisActiveStyle["--activeBorderWidth"] : (this.options.hoverShowBorder ? hoverBorderW : 0),
            "--hoverWritingMode": this.options.hoverIsSameActive ? thisActiveStyle["--activeWritingMode"] : this.options.hoverWritingMode,
            "--hoverBorderTopLeftRadius": this.options.hoverIsSameActive ? thisActiveStyle["--activeBorderTopLeftRadius"] : (this.options.hoverBorderTopLeftRadius + "px"),
            "--hoverBorderTopRightRadius": this.options.hoverIsSameActive ? thisActiveStyle["--activeBorderTopRightRadius"] : (this.options.hoverBorderTopRightRadius + "px"),
            "--hoverBorderBottomLeftRadius": this.options.hoverIsSameActive ? thisActiveStyle["--activeBorderBottomLeftRadius"] : (this.options.hoverBorderBottomLeftRadius + "px"),
            "--hoverBorderBottomRightRadius": this.options.hoverIsSameActive ? thisActiveStyle["--activeBorderBottomRightRadius"] : (this.options.hoverBorderBottomRightRadius + "px"),
          }
        }
        return {
          ...this.bgStyle,
          ...thisStyle,
          ...this.activeBgStyle,
          ...this.hoverBgStyle,
          ...thisActiveStyle,
          // ...thisHoverStyle
        }
      } else return null
    }
  },
  methods: {
    handlePopover(msg) {
      if(msg.sourceId === this.options.popoverPath) {
        this.$changeOptionsEV(msg.openPopover, "openPopover", false, null, this.myid, true)
      }
    },
    // 清除误加入的脏数据cover属性
    clearOptionsCover() {
      if (this.options.cover) {
        this.$changeOptionsEV(null, "cover", false, undefined, this.activeIds)
      }
    },
    checkAndSetVal(opt, key, optname, val) {
      //兼容为NaN或没有的数值数据
      if (!opt.hasOwnProperty(key) || opt[key] !== opt[key] || opt[key] === null || opt[key] === undefined) {
        this.$changeOptionsEV(val, optname, false, null, this.myid)
        return val
      }
    },
    textClickEvent() {
      if(this.isCollectButton || this.isLikeButton){
        //收藏
        if(this.isCollectButton){
          if(this.activeButton){
            /*this.$confirm("确定取消该收藏吗？", "", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: true
            }).then(() => {*/
              this.activeButton = false
              this.$changeOptionsEV(0, "iconSrcType1", false, null, this.myid)
            /*}).catch(() => {
              this.activeButton = true
              this.$changeOptionsEV(2, "iconSrcType1", false, null, this.myid)
            })*/
          }else{
            this.activeButton = true
            /*this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              message: "收藏成功",
              type: "success"
            })*/
            this.$changeOptionsEV(2, "iconSrcType1", false, null, this.myid)
          }
        }
        else if(this.isLikeButton){
          this.activeButton = !this.activeButton
          if(this.activeButton){
            this.likeNumber++
            this.$changeOptionsEV(2, "iconSrcType1", false, null, this.myid)
          }else{
            this.likeNumber--
            this.$changeOptionsEV(0, "iconSrcType1", false, null, this.myid)
          }
          //改为 悬浮 鼠标挪开再根据情况修改状态
          // this.$changeOptionsEV(1, "iconSrcType1", false, null, this.myid)
        }
        return
      }
      // 返回按钮
      if(this.isReturnButton){
        // 预览页面使用
        if (!this.isBigScreenPreview()) {
          return
        }
        history.go(-1)
        return
      }
      // 预览页面使用
      if (!this.options.linkUrl) {
        return
      }
      if (this.request_prefix === "bigScreen" && !this.isBigScreenPreview()) {
        return
      }
      if (this.request_prefix !== "bigScreen" && !isSsrPage()) {
        return
      }
    },
    noCacheComponentLayout() {
      // 在四边栏中 不控制
      if (!this.dataIds.uid) return false
      // 在中间内容区
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.dataIds, "rect")
      let filedMapping = this.options && this.options.filedMapping && this.options.filedMapping.flag
      if (rectAttr && rectAttr.shape !== "emptyLayoutComponent") return false
      return filedMapping && rectAttr.options && rectAttr.options.noCacheComponent
    },
    dbEditContent() {
      if (this.isBigScreenPreview() || this.noCacheComponentLayout() || this.isCollectButton || this.isLikeButton) {
        return
      }
      this.isEditStatu = true
      this.tempContent = this.getTextContent
      this.$nextTick(() => {
        this.$refs.btnInner.focus()
        // this.$refs.btnInner.select()
      })
      sessionStorage.setItem("isBtnEditStatu", true)
      this.activeIds = JSON.parse(JSON.stringify(this.ids))
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids, flag: false })
      // this.$nextTick(() => {
      //   this.getSelectPos()
      // })
    },
    // 将光标移动到最后面
    getSelectPos() {
      // let esrc = this.$refs.btnInner
      // let range = document.createRange()
      // range.selectNodeContents(esrc)
      // range.collapse(false)
      // let sel = window.getSelection()
      // sel.removeAllRanges()
      // sel.addRange(range)
    },
    dbChangeContent(event) {
      if(this.isCollectButton || this.isLikeButton){
        // 点赞收藏按钮禁止双击修改内容，为了避免和选中冲突
        return
      }
      this.isEditStatu = false
      sessionStorage.removeItem("isBtnEditStatu")
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.activeIds, flag: true })
      let getTextContent = event.target.innerHTML.replace(/<[^>]+>/g, "<br>").replace(/(<br>)*$/g, "")
      this.$changeOptionsEV(getTextContent, "content", false, undefined, this.activeIds)
    },
    blueEvent() {
      if(this.isCollectButton || this.isLikeButton){
        // 点赞收藏按钮禁止双击修改内容，为了避免和选中冲突
        return
      }
      sessionStorage.removeItem("isBtnEditStatu")
      this.isEditStatu = false
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.activeIds, flag: true })
      this.$changeOptionsEV(this.tempContent, "content", false, undefined, this.activeIds)
    },
    keyDownEvent() {
      let _this = this
      let key = window.event.keyCode
      // esc键   取消克隆模式
      if (key === 13 && _this.isEditStatu) {
        this.blueEvent()
      }
    },
    //获取选中、悬浮的背景
    getContainerBgStyle(curBackground, isThemeColor) {
      let containerBg = {
        backgroundImage: ""
      }
      if (
          !curBackground ||
          !Array.isArray(curBackground) ||
          (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: isThemeColor ? true : false,
            color:
                this.options.bgColor && this.options.bgColor.color
                    ? this.options.bgColor.color
                    : this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
                ? `${containerBg.backgroundSize},${bg.clipSize}`
                : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},${bg.alignType}`
                : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},${bg.repeatType}`
                : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //     ? this.$store.state[this.request_prefix].page.themeColor
            //     : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                  ? `${containerBg.backgroundPosition},center`
                  : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                  ? `${containerBg.backgroundRepeat},no-repeat`
                  : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //     dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                  ? `${containerBg.backgroundPosition},center`
                  : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                  ? `${containerBg.backgroundRepeat},no-repeat`
                  : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    //收藏按钮的悬浮
    buttonMouseenter() {
      if(this.isCollectButton || this.isLikeButton){
        this.$changeOptionsEV(1, "iconSrcType1", false, null, this.myid)
      }
    },
    buttonMouseleave() {
      if(this.isCollectButton || this.isLikeButton){
        if(this.activeButton){
          this.$changeOptionsEV(2, "iconSrcType1", false, null, this.myid)
        }else{
          this.$changeOptionsEV(0, "iconSrcType1", false, null, this.myid)
        }
      }
    },
    async updateData() {
      this.updateNormalRect.call(
        this,
        data => {
          if (typeof data === "string") {
            this.$changeOptionsEV(data, "content", false, null, this.myid, true)
          } else {
            // 如果首页绑定了字段匹配 不能获取第一个值
            if (
              !this.options.currentFiledMapping ||
              (this.options.currentFiledMapping && !this.options.currentFiledMapping.isChecked)
            ) {
              if (data.length === 0) {
                this.$changeOptionsEV("", "content", false, null, this.myid, true)
              } else {
                if(data && data[0]){
                  this.$changeOptionsEV(data[0][Object.keys(data[0])[0]].value, "content", false, null, this.myid, true)
                }
              }
            } else if (this.options.currentFiledMapping && this.options.currentFiledMapping.fieldFlag) {
              if(data && data[0]){
                const dataType = this.options.currentFiledMapping.dataType
                const data1 = data[0][this.options.currentFiledMapping.fieldFlag]
                let tempDataValue = data1.value
                if (dataType === "dataKey") {
                  tempDataValue = data1.key + "：" + data1.value
                } else if (dataType === "dataName") {
                  tempDataValue = data1.key
                }
                this.$changeOptionsEV(tempDataValue, "content", false, null, this.myid, true)
              }
            }
          }
        },
        1
      )
    }
  }
}
</script>

<style scoped>
.btn-container {
  width: 100%;
  height: 100%;
}
.cx-button {
  position: relative;
  line-height: 100%;
  pointer-events: none;
}
.btn-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  /*position: absolute;*/
  width: 100%;
  /*text-align: center;*/
  transition: transform 0.5s;
  /*box-sizing: content-box;*/
}

.btn-inner.column {
  flex-direction: column;
}

::v-deep.btn-inner svg * {
  stroke: var(--color);
}
.inlineBlock {
  display: inline-block;
  vertical-align: middle;
}
.button-inp {
  background: transparent;
  color: inherit !important;
  font-size: inherit !important;
  max-width: 100%;
  text-align: center;
}
.btn-inner>span{
  text-decoration: inherit;
}
.btn-inner>span:focus {
  outline: none;
}
.btn-inner.btn-collect-like.btn-active{
  background: var(--activeBackgroundColor) !important;
  background-image: var(--activeBackgroundImage) !important;
  background-size: var(--activeBackgroundSize) !important;
  background-position: var(--activeBackgroundPosition) !important;
  background-repeat: var(--activeBackgroundRepeat) !important;
  background-color: var(--activeBackgroundColor) !important;

  letter-spacing: var(--activeLetterSpacing) !important;
  text-indent: var(--activeLetterSpacing) !important;
  font-style: var(--activeFontStyle) !important;
  font-family: var(--activeFontFamily) !important;
  opacity: var(--activeOpacity) !important;
  font-size: var(--activeFontSize) !important;
  font-weight: var(--activeFontWeight) !important;
  text-decoration: var(--activeTextDecoration) !important;
  transform: var(--activeRotate) !important;
  border-style: var(--activeBorderStyle) !important;
  border-color: var(--activeBorderColor) !important;
  border-width: var(--activeBorderWidth) !important;
  writing-mode: var(--activeWritingMode) !important;
  border-top-left-radius: var(--activeBorderTopLeftRadius) !important;
  border-top-right-radius: var(--activeBorderTopRightRadius) !important;
  border-bottom-left-radius: var(--activeBorderBottomLeftRadius) !important;
  border-bottom-right-radius: var(--activeBorderBottomRightRadius) !important;
}
/* .btn-inner.btn-collect-like:hover{
  background: var(--hoverBackgroundColor) !important;
  background-image: var(--hoverBackgroundImage) !important;
  background-size: var(--hoverBackgroundSize) !important;
  background-position: var(--hoverBackgroundPosition) !important;
  background-repeat: var(--hoverBackgroundRepeat) !important;
  background-color: var(--hoverBackgroundColor) !important;

  letter-spacing: var(--hoverLetterSpacing) !important;
  text-indent: var(--hoverLetterSpacing) !important;
  font-style: var(--hoverFontStyle) !important;
  font-family: var(--hoverFontFamily) !important;
  opacity: var(--hoverOpacity) !important;
  font-size: var(--hoverFontSize) !important;
  font-weight: var(--hoverFontWeight) !important;
  text-decoration: var(--hoverTextDecoration) !important;
  transform: var(--hoverRotate) !important;
  border-style: var(--hoverBorderStyle) !important;
  border-color: var(--hoverBorderColor) !important;
  border-width: var(--hoverBorderWidth) !important;
  writing-mode: var(--hoverWritingMode) !important;
  border-top-left-radius: var(--hoverBorderTopLeftRadius) !important;
  border-top-right-radius: var(--hoverBorderTopRightRadius) !important;
  border-bottom-left-radius: var(--hoverBorderBottomLeftRadius) !important;
  border-bottom-right-radius: var(--hoverBorderBottomRightRadius) !important;
} */
</style>
